import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMobile = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M17.333 28.333c0-6.913 0-10.37 2.148-12.518S25.086 13.667 32 13.667s10.371 0 12.519 2.148c2.148 2.147 2.148 5.605 2.148 12.518v7.334c0 6.914 0 10.37-2.148 12.518S38.914 50.334 32 50.334s-10.37 0-12.519-2.148c-2.148-2.147-2.148-5.604-2.148-12.518z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M45.292 28.333c0-3.495-.003-5.979-.256-7.863-.248-1.844-.714-2.907-1.49-3.683s-1.838-1.241-3.683-1.49c-1.884-.253-4.367-.255-7.863-.255s-5.98.002-7.863.256c-1.845.248-2.907.714-3.683 1.49-.776.775-1.242 1.838-1.49 3.682-.253 1.884-.256 4.368-.256 7.863v7.334c0 3.495.003 5.979.256 7.863.248 1.845.714 2.907 1.49 3.683s1.838 1.241 3.683 1.49c1.884.253 4.367.255 7.863.255s5.98-.002 7.863-.256c1.845-.248 2.907-.713 3.683-1.49.776-.775 1.242-1.838 1.49-3.682.253-1.884.256-4.368.256-7.863zm2.75 7.334c0 3.418.002 6.12-.281 8.23-.29 2.15-.899 3.888-2.27 5.26-1.372 1.372-3.111 1.981-5.26 2.27-2.11.284-4.813.281-8.231.281s-6.12.003-8.23-.28c-2.15-.29-3.889-.899-5.26-2.27-1.372-1.373-1.982-3.112-2.27-5.26-.284-2.11-.282-4.813-.282-8.231v-7.334c0-3.418-.002-6.12.281-8.23.29-2.15.899-3.888 2.27-5.26 1.372-1.372 3.111-1.981 5.26-2.27 2.11-.284 4.813-.281 8.231-.281s6.12-.003 8.23.28c2.15.29 3.889.9 5.26 2.271 1.372 1.372 1.982 3.11 2.27 5.26.284 2.11.282 4.812.282 8.23z"
      />
      <path fill="hsl(var(--system-icon-white))" d="M37.5 44.833h-11z" />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M37.5 43.458a1.375 1.375 0 1 1 0 2.75h-11a1.375 1.375 0 0 1 0-2.75z"
      />
    </svg>
  );
};
export default SvgMobile;
